/**
 * Coerces a value from API/unknown to a string for use in components and metadata.
 * Use wherever GraphQL or API responses are typed as unknown but we need a string (e.g. title, excerpt, content, logo).
 */
export function asString(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}
